import { render, staticRenderFns } from "./plan_detail.vue?vue&type=template&id=01cdb968&scoped=true&"
import script from "./plan_detail.vue?vue&type=script&lang=js&"
export * from "./plan_detail.vue?vue&type=script&lang=js&"
import style0 from "./plan_detail.vue?vue&type=style&index=0&id=01cdb968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cdb968",
  null
  
)

export default component.exports